import { axiosInstance } from "@/api/axios";

export interface SelfSystemPermissionsItems {
    Action: string;
    Access: boolean;
}

export interface SelfSystemPreferences {
    Theme: string,
    Language: string
}

export interface SelfSystemPermissionsResponse {
    pereferences: SelfSystemPreferences;
    permissions: SelfSystemPermissionsItems[];
}

export const GetSelfSystemPermissionsAPI = async (): Promise<SelfSystemPermissionsResponse> => {

    const response = await axiosInstance.get<SelfSystemPermissionsResponse>(
        `secured/profile/self_permissions/system`
    );

    return response.data
}
